import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { AgencyProfileDetails, PagedList } from '@rma/dashboard/generic/domain/to-be-sorted';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { httpParamMapper } from '@rma/dashboard/generic/util/http';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import type {
  AgencyAgent,
  AgencyAgentFilter,
  AgencyAgentFilters,
  AgencyAgentsSearchResponse,
} from '../../entities/legacy/agency-agent.model';

@Injectable({
  providedIn: 'root',
})
export class AgencyProfileService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getAgencyProfileDetails(agencyCode: string): Observable<AgencyProfileDetails> {
    const url = this.rmaApiUrl(`Agencies/Code-${agencyCode}/Details`);
    return this.httpClient.get<AgencyProfileDetails>(url);
  }

  public searchAgencyAgents(filters: AgencyAgentFilters): Observable<AgencyAgentsSearchResponse> {
    const params = httpParamMapper(filters);
    const url = this.rmaApiUrl('/Agencies/Me/Agents/Search');
    return this.httpClient.get<AgencyAgentsSearchResponse>(url, {
      ...RMA_DEFAULT_HTTP_OPTIONS,
      params,
    });
  }

  public getAgencyAgents(
    agencyCode: string,
    filters: AgencyAgentFilter = {
      sortBy: 'Alphabetical',
      skip: 0,
      take: 1000,
    },
  ): Observable<PagedList<AgencyAgent & { sortBy: string }>> {
    const params = httpParamMapper(filters);

    return this.httpClient.get<PagedList<AgencyAgent & { sortBy: string }>>(this.rmaApiUrl(`v2/Agencies/Code-${agencyCode}/Agents`), {
      ...RMA_DEFAULT_HTTP_OPTIONS,
      params,
    });
  }
}
